import { BaitData, TrapActivityType } from 'api/traps/SRBMTraps/types';
import './BaitCell.scss';
import VisitingBaitIcon from 'components/Icons/Bait/VisitingBaitIcon';
import BaitSuccess from 'components/Icons/Bait/BaitSuccess';
import BaitIcon from 'components/Icons/Bait/BaitIcon';

interface BaitCellProps {
  data: BaitData;
  activity_type: TrapActivityType;
  width?: number;
}

const BaitCell: React.FC<BaitCellProps> = ({ data, activity_type, width = 15 }) => {
  let icon: JSX.Element;

  if (activity_type === TrapActivityType.ACTIVITY) {
    icon = <VisitingBaitIcon height={30} color="#f7b84b" />;
  } else if (activity_type === TrapActivityType.CONSUMPTION) {
    icon = <BaitIcon height={30} color="#f06548" />;
  } else {
    icon = <BaitSuccess />;
  }

  const getColor = (activity_type?: string) => {
    switch (activity_type) {
      case TrapActivityType.ACTIVITY:
        return 'warning';
      case TrapActivityType.CONSUMPTION:
        return 'danger';
      default:
        return 'success';
    }
  };
  // bg-${data.status}${data.status === 'success' ? '-custom' : ''}
  return (
    <div style={{ width: `${width}px` }} title={`Bait filling: ${data.bait_filling}`}>
      <span
        className={`position-absolute mx-4 my-1 top-0 badge rounded-pill bg-${getColor(activity_type)}`}
        style={{ marginRight: '10px' }}
      >
        {data.actual_eaten_bait}
      </span>
      {icon}
    </div>
  );
};

export default BaitCell;
